import { render, staticRenderFns } from "./IrrobaSvg.vue?vue&type=template&id=63ee8721"
import script from "./IrrobaSvg.vue?vue&type=script&lang=js"
export * from "./IrrobaSvg.vue?vue&type=script&lang=js"
import style0 from "./IrrobaSvg.vue?vue&type=style&index=0&id=63ee8721&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports